import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import styles from './Program.css';

class WrappedPanelHeader extends Component {
  render() {
    const { isOpened, isValid, isVisited } = this.props;
    let icon = <FontAwesome name="chevron-up" />;
    let titleStyle = styles['panel-title-disabled'];

    if (!isOpened) {
      if (!isVisited) {
        icon = <FontAwesome name="chevron-down" />;
      } else {
        titleStyle = styles['panel-title'];
        if (isValid) {
          icon = <FontAwesome style={{ color: 'green' }} name="check-circle" />;
        } else {
          icon = <FontAwesome style={{ color: 'red' }} name="minus-circle" />;
        }
      }
    } else {
      titleStyle = styles['panel-title'];
    }

    return (
      <div className="cursor-pointer">
        <span className={titleStyle}>{this.props.title}</span>
        <span className="pull-right">{icon}</span>
      </div>
    );
  }
}

WrappedPanelHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  isValid: PropTypes.bool,
  isOpened: PropTypes.bool.isRequired,
};

export default WrappedPanelHeader;
